import useOffer from 'hooks/Offers/useOffer'
import usePropertyOfferMapping from 'hooks/Offers/usePropertyOfferMapping'
import useBedbankPackageViews from 'hooks/useBedbankPackageViews'

type ViewData = [
  bedbankPackageViews: Array<App.BedbankOfferPackageView>,
  fetching: boolean,
]

/**
 * @deprecated Consider using the equivalent selector `getPropertyMappedBedbankPackageOptions`
 */
function usePropertyBedbankViews(propertyId: string): ViewData {
  // Get the mapping for this property page so we know what bedbank offer to fetch
  const [mapping] = usePropertyOfferMapping(propertyId)
  // Get the bedbank offer for this property mapping
  const [bedbankOffer] = useOffer<App.BedbankOffer>(mapping?.bedbankOfferId)
  return useBedbankPackageViews(bedbankOffer)
}

export default usePropertyBedbankViews
